<template>
    <div>
        <kgr-lightbox
            v-model="showLightbox"
            :headline="$t('kindergarten.holiday.import')"
            animated
            @post-input="closeAndAbort()"
        >
            <div
                class="kgr-row kgr-text--leftAligned dialog"
                v-html="$t('kindergarten.holiday.import.text', {'year': year})"
            ></div>
            <div class="kgr-row">
                <kgr-button
                    value="Ok"
                    @click="onOkButtonClick"
                />
                <kgr-button
                    type="grey"
                    :value="$t('cancel')"
                    @click="closeAndAbort"
                />
            </div>
        </kgr-lightbox>
    </div>
</template>

<script>
import KgrButton from '../../common/form/button/KgrButton';
import Lightbox from '../../common/modal/Lightbox';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-lightbox': Lightbox,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        year: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            showLightbox: this.show,
        }
    },
    watch: {
        show() {
            this.showLightbox = this.show;
        },
    },
    methods: {
        onOkButtonClick() {
            this.$emit('import');
            this.closeAndAbort();
        },
        closeAndAbort() {
            this.showLightbox = false;
            this.$emit('close');
        },
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.dialog {
    width: 350px;
}
</style>
